<template>
    <li class="nav-item">
        <template v-if="hasActions">
            <div class="wrapper-actions">
                <router-link :to="{ name: item.route }" class="nav-link">
                    <i :class="['nav-icon', item.icon ]" />
                    <span>{{ $t(item.text) }}</span>
                </router-link>
                <router-link
                    v-for="(action, idx) in actions"
                    :key="`item-action-${item.route}-${idx}`"
                    :to="{ name: action.route }" class="nav-link">
                    <i :class="['nav-icon action', action.icon ]" />
                    <span>{{ $t(action.text) }}</span>
                </router-link>
            </div>
        </template>
        <template v-else>
            <router-link :to="{ name: item.route }" class="nav-link">
                <i :class="['nav-icon', item.icon ]" />
                <span>{{ $t(item.text) }}</span>
            </router-link>
        </template>
    </li>
</template>

<script>

export default {
    mixins: [],
    props: {
        item: {
            type: Object,
            require: true,
        }
    },
    data() {
        return {

        }
    },
    computed: {
        actions() {
            return this.item?.actions ?? [];
        },
        hasActions() {
            return this.actions.length>0;
        },
    },
}

</script>